import { Component , Prop} from 'vue-property-decorator';
import * as tsx from 'vue-tsx-support';
import { StylePropsType } from './PropsType';
import classnames from "classnames";
import './style.less';

@Component
export default class ErrorText extends tsx.Component<StylePropsType> {
  
  @Prop({default: 'cp-error-text'}) public prefixCls?: string;
  @Prop() className?: string;
  
  render() {
    const {prefixCls, className, style} = this.$props;
    const wrapCls = classnames(prefixCls, className)
    return (
      <div style={style} class={wrapCls}>{Object.values(this.$slots)}</div>
    )
  }
  
}